<div class="switch-view-container">
  <ng-container *ngIf="(state | async).questions.length; else noQuestions">
    <div
      class="table-container uk-margin-bottom"
      [ngClass]="{
        'table-height-user': (state | async).questions.length && url.includes('users'),
        'table-height-pitch': (state | async).questions.length && url.includes('pitches')
      }">
      <table class="uk-table uk-table-justify uk-table-divider uk-table-striped uk-table-hover uk-table-small uk-table-middle">
        <thead>
          <tr>
            <th class="uk-text-nowrap" i18n="@@question">question</th>

            <th *ngIf="author" class="uk-text-nowrap" i18n="@@author">author</th>

            <th class="uk-text-nowrap" i18n="@@answer">answer</th>

            <th class="uk-text-nowrap" i18n="@@pitch" *ngIf="!url.includes('pitches')">pitch</th>

            <th class="uk-table-shrink uk-text-right" i18n="@@status">status</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let question of (state | async).questions">
            <td>
              <ng-container *ngIf="question.text.length <= 70; else questionModal">
                {{ question.text }}
              </ng-container>

              <ng-template #questionModal>
                <div appFullText [title]="'Question'" [text]="question.text" [modal]="modal" class="pointer">
                  {{ question.text.substr(0, 67) + '...' }}
                </div>
              </ng-template>
            </td>

            <td *ngIf="author">
              <ng-container *ngIf="question.user.first_name && question.user.last_name; else noQuestionAuthorNames">
                <a [routerLink]="['/users', question.user.id]">
                  {{ question.user.first_name + ' ' + question.user.last_name | namesWithDash }}
                </a>
              </ng-container>

              <ng-template #noQuestionAuthorNames>
                <a [routerLink]="['/users', question.user.id]"> {{ question.user.email | userWithoutName }}</a>
              </ng-template>
            </td>

            <td (click)="editAnswer(question.text, question.answer?.text, question.id, question.answer?.user?.id)" class="pointer">
              <ng-container *ngIf="question.answer?.text; else noAnswerText">
                <span>
                  <ng-container *ngIf="question.answer.text.length <= 70; else shortAnswer">
                    {{ question.answer.text }}
                  </ng-container>

                  <ng-template #shortAnswer>
                    {{ question.answer.text.substr(0, 67) + '...' }}
                  </ng-template>
                </span>
              </ng-container>

              <ng-template #noAnswerText>
                <span uk-icon="minus"></span>
              </ng-template>
            </td>

            <td *ngIf="!url.includes('pitches')">
              <a [routerLink]="['/pitches', question.pitch.id]">{{ question.pitch.name }}</a>
            </td>

            <td class="uk-text-center switcher-container">
              <app-status-switcher [action]="action" [eyeIcon]="true" [id]="question.id" [status]="question.muted"> </app-status-switcher>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <ng-template #noQuestions>
    <div *ngIf="(state | async).alreadyRequested.includes(switchViews.Questions)" class="uk-text-center" i18n="@@noQuestionsUser">
      There are no questions related to the user.
    </div>
  </ng-template>
</div>
